/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgSpecOnAzure
 */
export interface OrgSpecOnAzure {
    /**
     * 
     * @type {string}
     * @memberof OrgSpecOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecOnAzure
     */
    spec_name: string;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecOnAzure
     */
    arc_flash_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecOnAzure
     */
    fall_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecOnAzure
     */
    impact_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecOnAzure
     */
    current_sensitivity: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecOnAzure
     */
    voltage_range: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecOnAzure
     */
    voltage_sensitivity: number;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecOnAzure
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the OrgSpecOnAzure interface.
 */
export function instanceOfOrgSpecOnAzure(value: object): value is OrgSpecOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('spec_name' in value) || value['spec_name'] === undefined) return false;
    if (!('arc_flash_alerts' in value) || value['arc_flash_alerts'] === undefined) return false;
    if (!('fall_alerts' in value) || value['fall_alerts'] === undefined) return false;
    if (!('impact_alerts' in value) || value['impact_alerts'] === undefined) return false;
    if (!('current_sensitivity' in value) || value['current_sensitivity'] === undefined) return false;
    if (!('voltage_range' in value) || value['voltage_range'] === undefined) return false;
    if (!('voltage_sensitivity' in value) || value['voltage_sensitivity'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function OrgSpecOnAzureFromJSON(json: any): OrgSpecOnAzure {
    return OrgSpecOnAzureFromJSONTyped(json, false);
}

export function OrgSpecOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgSpecOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'spec_name': json['spec_name'],
        'arc_flash_alerts': json['arc_flash_alerts'],
        'fall_alerts': json['fall_alerts'],
        'impact_alerts': json['impact_alerts'],
        'current_sensitivity': json['current_sensitivity'],
        'voltage_range': json['voltage_range'],
        'voltage_sensitivity': json['voltage_sensitivity'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function OrgSpecOnAzureToJSON(json: any): OrgSpecOnAzure {
    return OrgSpecOnAzureToJSONTyped(json, false);
}

export function OrgSpecOnAzureToJSONTyped(value?: OrgSpecOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'spec_name': value['spec_name'],
        'arc_flash_alerts': value['arc_flash_alerts'],
        'fall_alerts': value['fall_alerts'],
        'impact_alerts': value['impact_alerts'],
        'current_sensitivity': value['current_sensitivity'],
        'voltage_range': value['voltage_range'],
        'voltage_sensitivity': value['voltage_sensitivity'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

